/* global $, fitText, Vue */
import utils from './helpers/utilities'
import OfferForm from './components/public-forms/OfferForm.vue'
import GeneralInquiry from './components/public-forms/GeneralInquiry.vue'
import FreeSamples from './components/public-forms/FreeSamples.vue'
import OwnersRefill from './components/public-forms/OwnersRefill.vue'
import VeterinaryRefill from './components/public-forms/VeterinaryRefill.vue'
import RegisterForm from './components/public-forms/RegisterForm.vue'
import AccountForm from './components/public-forms/AccountForm.vue'
import NewPrescription from './components/public-forms/NewPrescription.vue'
import SearchBlock from './components/search/SearchBlock.vue'

require('./bootstrap-fe')

Vue.prototype.$utils = utils

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
const app = new Vue({
  components: {
    OfferForm,
    GeneralInquiry,
    FreeSamples,
    OwnersRefill,
    VeterinaryRefill,
    RegisterForm,
    AccountForm,
    NewPrescription,
    SearchBlock
  },
  data: () => {
    return {
      ajaxSearch: false
    }
  }
}).$mount('#app')

$('.type--selector').on('click', function (e) {
  e.preventDefault()
  let tableSelector = $(e.target).attr('href')
  let flavorSelector = tableSelector.replace('#form-', '#flavor-')
  let imageSelector = tableSelector.replace('#form-', '#product-form-image-')
  let descriptionSelector = tableSelector.replace('#form-', '#product-form-description-')
  let newActiveTable = $(tableSelector)
  let newActiveFlavor = $(flavorSelector)
  let newActiveImage = $(imageSelector)
  let newActiveDescription = $(descriptionSelector)
  let currentActiveSwitch = $('.item.type--selector.active')
  let currentActiveTable = $('.table.type--price--table.active')
  let currentActiveFlavor = $('.type--flavor.active')
  let currentActiveImage = $('.image--wrapper img.active')
  let currentActiveDescription = $('.type--description.active')

  currentActiveSwitch.removeClass('active')
  currentActiveTable.removeClass('active')
  currentActiveFlavor.removeClass('active')
  currentActiveImage.removeClass('active')
  currentActiveDescription.removeClass('active')
  $(e.target).addClass('active')
  newActiveTable.addClass('active')
  newActiveFlavor.addClass('active')
  newActiveImage.addClass('active')
  newActiveDescription.addClass('active')
})

$('a.collapse').on('click', function (e) {
  e.preventDefault()
  $(e.target).closest('form').addClass('collapsed')
})

$('a.expand').on('click', function (e) {
  e.preventDefault()
  $(e.target).closest('form').removeClass('collapsed')
})

$('.scrollToHistory').on('click', function (e) {
  e.preventDefault()
  $('html, body').animate({
    scrollTop: $("#pointHistory").offset().top
}, 1000)
})

document.addEventListener('DOMContentLoaded', () => {
  if (undefined !== window.fitText) {
    let promoTitles = document.querySelectorAll('.discount')
    if (promoTitles) {
      promoTitles.forEach((item) => {
        fitText(item, 2)
      })
    }
    let promoSubTitles = document.querySelectorAll('.discount-subtitle')
    if (promoSubTitles) {
      promoSubTitles.forEach((item) => {
        fitText(item, 2.5)
      })
    }
  }
})

$('.popup_close').on('click', function (e) {
  $('.popup-overlay, .popup').removeClass('show')
  $.cookie('pupup', 1, { expires: 60 / 1440, path: '/' });
})

if($.cookie('pupup') === undefined){
  $('.popup-overlay, .popup').addClass('show');
}